import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { R as Representative } from './Business.js';
import { F as FormController } from './form.js';
import { i as identitySchema } from './business-identity-schema.js';
import { P as PaymentProvisioningLoading } from './payment-provisioning-loading.js';
import { B as BusinessFormStep } from './event-types.js';
import { d as defineCustomElement$8 } from './custom-popper2.js';
import { d as defineCustomElement$7 } from './form-control-date2.js';
import { d as defineCustomElement$6 } from './form-control-number-masked2.js';
import { d as defineCustomElement$5 } from './form-control-select2.js';
import { d as defineCustomElement$4 } from './form-control-text2.js';
import { d as defineCustomElement$3 } from './form-control-tooltip2.js';
import { d as defineCustomElement$2 } from './business-representative-form-inputs.js';
import { d as defineCustomElement$1 } from './identity-address-form.js';

const BusinessRepresentativeFormStepCore = /*@__PURE__*/ proxyCustomElement(class BusinessRepresentativeFormStepCore extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.stepCompleteEvent = createEvent(this, "complete-form-step-event", 7);
        this.errorEvent = createEvent(this, "error-event", 7);
        this.formLoading = createEvent(this, "formLoading", 7);
        this.errors = {};
        this.representative = {};
        this.isLoading = false;
        this.getData = () => {
            this.formLoading.emit(true);
            this.isLoading = true;
            this.getBusiness({
                onSuccess: (response) => {
                    this.representative = new Representative(response.data.representative || {});
                    this.formController.setInitialValues(Object.assign({}, this.representative));
                },
                onError: ({ error, code, severity }) => {
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => {
                    this.formLoading.emit(false);
                    this.isLoading = false;
                }
            });
        };
        this.sendData = (onSuccess) => {
            let submittedData;
            this.formLoading.emit(true);
            this.patchBusiness({
                payload: this.patchPayload,
                onSuccess: (response) => {
                    submittedData = response;
                    onSuccess();
                },
                onError: ({ error, code, severity }) => {
                    submittedData = error;
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => {
                    this.stepCompleteEvent.emit({ response: submittedData, formStep: BusinessFormStep.representative });
                    this.formLoading.emit(false);
                }
            });
        };
    }
    async validateAndSubmit({ onSuccess }) {
        this.formController.validateAndSubmit(() => this.sendData(onSuccess));
    }
    get patchPayload() {
        let formValues = new Representative(this.formController.values.getValue()).payload;
        return { representative: formValues };
    }
    componentWillLoad() {
        this.getBusiness && this.getData();
        this.formController = new FormController(identitySchema('representative', this.allowOptionalFields));
    }
    componentDidLoad() {
        this.formController.errors.subscribe(errors => {
            this.errors = Object.assign({}, errors);
        });
    }
    render() {
        if (this.isLoading) {
            return (h(PaymentProvisioningLoading, null));
        }
        return (h("justifi-business-representative-form-inputs", { representativeDefaultValue: this.formController.getInitialValues(), errors: this.errors, formController: this.formController }));
    }
}, [0, "justifi-business-representative-form-step-core", {
        "getBusiness": [16, "get-business"],
        "patchBusiness": [16, "patch-business"],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "formController": [32],
        "errors": [32],
        "representative": [32],
        "isLoading": [32],
        "validateAndSubmit": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-business-representative-form-step-core", "custom-popper", "form-control-date", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-business-representative-form-inputs", "justifi-identity-address-form"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-business-representative-form-step-core":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessRepresentativeFormStepCore);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "justifi-business-representative-form-inputs":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessRepresentativeFormStepCore as B, defineCustomElement as d };
